import request from '@/http/request'

export const getWaveRunList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/wave_run/search`, { params })
}
export const refreshWaveRun = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-share-service/wave_run/manuallyRetrieve`, params, {
    refreshCode: true
  })
}
export const getWaveRunListTotal = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/wave_run/summaryReport`, { params })
}
export const manualUpdateWaveRun = () => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-share-service/wave_run/manualUpdateWaveRun`,
    {},
    {
      hiddenError: true
    }
  )
}
